const getFieldsInOrder = metadata => {
  const { form } = metadata;
  const formInOrder = Object.values(form).sort(
    (field1, field2) => field1.index - field2.index
  );
  return category => {
    if (category === 'dealer') return [...formInOrder];
    return formInOrder.filter(form => form.category === 'public');
  };
};

const getField = metadata => fieldName => metadata.form[fieldName];

const initFormState = metadata => () => {
  const { form } = metadata;
  return Object.values(form).reduce(
    (formState, field) =>
      Object.assign(formState, {
        [field.fieldName]: { value: field.defaultValue, error: undefined },
      }),
    {}
  );
};

const formApiCreater = metadata => ({
  getFieldsInOrder: getFieldsInOrder(metadata),
  getField: getField(metadata),
  initFormState: initFormState(metadata),
});

export default formApiCreater;



// WEBPACK FOOTER //
// ./src/modules/form.js